export default __webpack_public_path__ + "static/media/report_builder.b84a787a.svg";